import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {CheckboxComponent} from '@components/checkbox/checkbox.component';
import {VisibilityManager} from '../../managers/visibility.manager';

@Component({
  selector: 'app-osm-drawing-toolbar',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, CheckboxComponent],
  templateUrl: './osm-drawing-toolbar.component.html',
  styleUrl: './osm-drawing-toolbar.component.scss',
})
export class OsmDrawingToolbarComponent {
  @Input() direction: 'row' | 'column' = 'row';
  @Input({required: true}) visibilityManager!: VisibilityManager;

  @Input() distanceActive = false;
  @Input() rectangleActive = false;
  @Input() polygonActive = false;
  @Input() boxPolygonActive = false;
  @Input() customPolygonActive = false;

  @Output() toggleDistance = new EventEmitter<void>();
  @Output() enableRectangle = new EventEmitter<void>();
  @Output() enablePolygon = new EventEmitter<void>();
  @Output() enableBoxPolygon = new EventEmitter<void>();
  @Output() enableCustomPolygon = new EventEmitter<void>();
  @Output() clearAllDrawings = new EventEmitter<void>();
  @Output() openGeoUpload = new EventEmitter<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent): void {
    this.visibilityManager.closeMenuUnlessTargetInside(ev.target, '.visibility-tool-wrapper');
  }
}
